import PropTypes from "prop-types";
import { customRound } from "../../../../../utils/nutrition-util";

/**
 * MacrosDisplay
 * 
 * Shared component to display macro values (Protein, Carbs, Fat, Calories)
 * Used in both detailed and simplified meal planners
 */
export const MacrosDisplay = ({ 
  proteins = 0, 
  carbs = 0, 
  fats = 0, 
  calories = 0,
  className = "values"
}) => {
  return (
    <div className={className}>
      <div className="value">
        <div className="protein-container">P</div>
        <span>{customRound(proteins)}</span>
      </div>
      <div className="value">
        <div className="carbs-container">C</div>
        <span>{customRound(carbs)}</span>
      </div>
      <div className="value">
        <div className="fat-container">F</div>
        <span>{customRound(fats)}</span>
      </div>
      <div className="value">
        <div className="calories-container">K</div>
        <span>{customRound(calories)}</span>
      </div>
    </div>
  );
};

MacrosDisplay.propTypes = {
  proteins: PropTypes.number,
  carbs: PropTypes.number,
  fats: PropTypes.number,
  calories: PropTypes.number,
  className: PropTypes.string,
};

